<template>
  <div>
    <b-container class="pt-4">
      <p class="font-weight-bolder mt-3 h4 text-center intro">
        Hi, <span class="text-capitalize">{{ childName }}</span>
      </p>
      <component
        :is="currentComponent.component"
        @stepData="stepData"
        v-bind="currentProperties"
      ></component>
      <div v-if="buttonShouldBeDisplayed" class="d-flex w-100">
        <b-button
          class="atm-button bg-main mx-auto my-4 w-50"
          @click="nextStep(currentComponent.nextComponent)"
          :disabled="loaderSaved"
        >
          <b-spinner v-if="loaderSaved" label="Save" />
          <span v-else>{{ buttonText }}</span>
        </b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { setInitialSetup, setModuleFocusOn, setDisableFirstTime } from '@/onBoard/services';
import { loadUserData } from '@/auth';

export default {
  props: {
    modulesInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      currentComponent: this.getDynamicComponent('StepOneIntro'),
      moduleFocusSelected: '',
      buttonText: 'I get it',
      buttonShouldBeDisplayed: true,
      loaderSaved: false,
    };
  },
  computed: {
    currentProperties() {
      return { modules: this.modulesInfo };
    },
    userId() {
      return this.sessionStore.userId;
    },
    childName() {
      return this.sessionStore.childName;
    },
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
  },
  methods: {
    getDynamicComponent(currentStep) {
      return {
        component: () => import(`@/onBoard/components/${currentStep}`),
        nextComponent: this.getNextComponent(currentStep),
      };
    },
    getNextComponent(currentStep) {
      switch (currentStep) {
        case 'StepOneIntro':
          return 'StepTwoFocus';
        case 'StepTwoFocus':
          return 'StepThreeTime';
        case 'StepThreeTime':
          return 'SaveInitialSetup';
        default:
          return '';
      }
    },
    stepData({ focusSelected, timeDay, hours }) {
      if (focusSelected) {
        this.moduleFocusSelected = focusSelected;
      }
      if (timeDay && hours) {
        this.hour = hours;
        this.timeDay = timeDay;
      }
      this.buttonShouldBeDisplayed = true;
    },
    async sendInitialSetup() {
      this.loaderSaved = true;
      const body = {
        hour: this.hour,
        timeDay: this.timeDay === 'PM' ? '2' : '1',
        ModuleOrder: this.moduleFocusSelected,
        isChild: !this.userIsAParent,
      };
      try {
        if (!this.userIsAParent) {
          await setInitialSetup(this.userId, body);
          await setModuleFocusOn(this.userId, body);
        }
        await setDisableFirstTime(this.userId, body);
        await loadUserData();
        this.$router.push({ name: 'home' });
      } catch (error) {
        console.error(error);
      } finally {
        this.loaderSaved = false;
      }
    },
    nextStep(nextComponent) {
      if (nextComponent !== 'SaveInitialSetup') {
        this.currentComponent = this.getDynamicComponent(nextComponent);
      }
      switch (nextComponent) {
        case 'StepTwoFocus':
          this.buttonText = 'Next';
          this.buttonShouldBeDisplayed = false;
          break;
        case 'StepThreeTime':
          this.buttonText = 'Save';
          this.buttonShouldBeDisplayed = false;
          break;
        case 'SaveInitialSetup':
          this.sendInitialSetup();
          break;
        default:
          break;
      }
    },
  },
};
</script>
